module.exports = __webpack_public_path__ + "static/media/hipercard.df272bdd.png";